import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import {
  CountryViewModel,
  RequestPasswordResetCodeCommand,
  UserProxy,
} from '@/app/proxy/proxies';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppInitializerService } from '@/app/core/services/app-initializer.service';
import { findDefaultPhoneCountry } from '@/app/auth/shared/default-phone-country';

@Component({
  selector: 'auth-forgot-pwd',
  imports: [SharedModule],
  providers: [UserProxy],
  templateUrl: './forgot-pwd.component.html',
  styleUrl: './forgot-pwd.component.less',
})
export class ForgotPwdComponent implements OnInit, OnDestroy {
  email = '';
  phoneNumber: number;
  countries: CountryViewModel[] = [];
  selectedCountry: any;
  @Input() loginInputType = 'email';
  @Output() steperChange = new EventEmitter<string>();
  @Output() verifyOtpInfo = new EventEmitter<string>();

  // Subject for managing subscriptions
  private destroy$ = new Subject<void>();

  somethingWentWrong: boolean = false;
  errorMessage: string = '';

  constructor(
    private _router: Router,
    private _userProxy: UserProxy,
    private _authService: AuthService,
    private _applicationService: AppInitializerService
  ) {}

  ngOnInit(): void {
    this.countries = [...(this._applicationService.appStartupData?.countries ?? [])];
    this.countries.sort((a, b) => parseInt(a.phoneCode) - parseInt(b.phoneCode));
    this.selectedCountry = findDefaultPhoneCountry(this.countries);

    this._authService.email$.pipe(takeUntil(this.destroy$)).subscribe((email) => {
      this.email = email || '';
    });

    this._authService.phoneNumber$.pipe(takeUntil(this.destroy$)).subscribe((phoneNumber) => {
      this.phoneNumber = +phoneNumber;
    });
  }

  backButton() {
    this.steperChange.emit('login');
    this._router.navigate(['/auth/login']);
  }

  confirmForgotPassword() {
    let input = new RequestPasswordResetCodeCommand({
      email: this.loginInputType === 'email' ? this.email : undefined,
      phone: this.loginInputType === 'phone' ? this.phoneNumber.toString() : undefined,
      phoneCode: this.loginInputType === 'phone' ? this.selectedCountry.phoneCode.replace(/\+/g, '') : undefined,
    });
    if (this.loginInputType === 'email') {
      this._authService.setEmail(this.email);
    } else {
      this._authService.setPhoneNumber(this.phoneNumber.toString());
      this._authService.setPhoneCode(this.selectedCountry.phoneCode.replace(/\+/g, ''));
    }
    this._userProxy
      .user_RequestResetPassword(input)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.verifyOtpInfo.emit(res.result.sendToValue);
          this.steperChange.emit('verify-otp');
        } else {
          this.somethingWentWrong = true;
          this.errorMessage = res.errors[0].message;
        }
      });
  }

  ngOnDestroy(): void {
    // Complete the subject to unsubscribe from all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
